var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Card, Button, Icon } from '../../shared';
import { CaseApplicantsDetailsFooter } from './case-applicants-details-footer';
import { CaseApplicantsDetailsBody } from './case-applicants-details-body';
import { CaseApplicantsDetailsHeader } from './case-applicants-details-header';
import { EditClient } from '../add-client/edit-client';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
import './case-applicants.scss';
import { services } from '../../../shared';
export var CaseApplicantsDetails = function (_a) {
    var applicant = _a.applicant, documents = _a.documents, documentGridRefresh = _a.documentGridRefresh, clientId = _a.clientId, onUpdate = _a.onUpdate, updateApplicants = _a.updateApplicants, showUploadModal = _a.showUploadModal;
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var _c = useState(), clientData = _c[0], setClientData = _c[1];
    var _d = useState(false), modalVisible = _d[0], setModalVisible = _d[1];
    var _e = useState(), formTitles = _e[0], setFormTitles = _e[1];
    var _f = useState(), clientAddress = _f[0], setClientAddress = _f[1];
    var _g = useState(false), caseView = _g[0], setCaseView = _g[1];
    var _h = useState(false), isReset = _h[0], setReset = _h[1];
    var handleExpand = function () {
        setExpanded(!expanded);
    };
    var getClientAddress = function (addressId) { return __awaiter(void 0, void 0, void 0, function () {
        var address;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getAddress(addressId)];
                case 1:
                    address = (_a.sent()).data;
                    setClientAddress(address);
                    return [2 /*return*/];
            }
        });
    }); };
    var clientDetails = {
        id: clientId,
        titleId: applicant === null || applicant === void 0 ? void 0 : applicant.titleID,
        firstName: applicant === null || applicant === void 0 ? void 0 : applicant.firstName,
        surname: applicant === null || applicant === void 0 ? void 0 : applicant.surname,
        dateOfBirth: applicant === null || applicant === void 0 ? void 0 : applicant.dateOfBirth,
        email: applicant === null || applicant === void 0 ? void 0 : applicant.email,
        mobileNumber: applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber,
        address: clientAddress,
        correspondenceAddress: clientAddress,
        addressId: applicant === null || applicant === void 0 ? void 0 : applicant.addressId,
        applicantId: Number(applicant === null || applicant === void 0 ? void 0 : applicant.id),
        companyName: (applicant === null || applicant === void 0 ? void 0 : applicant.companyName) || (applicant === null || applicant === void 0 ? void 0 : applicant.customerName),
        customerTypeId: applicant === null || applicant === void 0 ? void 0 : applicant.customerTypeId,
        customerName: applicant === null || applicant === void 0 ? void 0 : applicant.customerName,
    };
    var getFormTitles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var titles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getTitles()];
                case 1:
                    titles = (_a.sent()).data;
                    setFormTitles(titles);
                    return [2 /*return*/];
            }
        });
    }); };
    var showModal = function (client) {
        setClientData(client);
        setModalVisible(true);
        setCaseView(true);
    };
    var hideModal = function () {
        setClientAddress(null);
        var clientDetails = {
            id: null,
            titleId: null,
            firstName: null,
            surname: null,
            dateOfBirth: null,
            email: null,
            mobileNumber: null,
            address: null,
            correspondenceAddress: null,
            addressId: applicant === null || applicant === void 0 ? void 0 : applicant.addressId,
            applicantId: null,
            companyName: applicant === null || applicant === void 0 ? void 0 : applicant.companyName,
            customerTypeId: applicant === null || applicant === void 0 ? void 0 : applicant.customerTypeId,
            customerName: applicant === null || applicant === void 0 ? void 0 : applicant.customerName,
        };
        setClientData(clientDetails);
        setModalVisible(false);
    };
    useEffect(function () {
        getClientAddress(applicant.addressId);
        getFormTitles();
    }, [clientId, applicant]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EditClient, { show: modalVisible, handleClose: hideModal, client: clientData, titles: formTitles, setToggle: setModalVisible, onUpdate: onUpdate, updateApplicants: updateApplicants, caseView: caseView, resetForm: setReset, isReset: isReset, modalMode: 'edit', customerTypeId: clientData === null || clientData === void 0 ? void 0 : clientData.customerTypeId }),
        React.createElement(Card, null,
            React.createElement(CaseApplicantsDetailsHeader, { firstName: applicant === null || applicant === void 0 ? void 0 : applicant.firstName, surname: applicant === null || applicant === void 0 ? void 0 : applicant.surname, isMainApplicant: applicant === null || applicant === void 0 ? void 0 : applicant.isMainApplicant, email: applicant === null || applicant === void 0 ? void 0 : applicant.email, mobileNumber: applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber, customerName: applicant === null || applicant === void 0 ? void 0 : applicant.customerName }),
            React.createElement(CaseApplicantsDetailsBody, { documents: !expanded ? documents === null || documents === void 0 ? void 0 : documents.slice(0, 3) : documents }),
            React.createElement(CaseApplicantsDetailsFooter, { expanded: expanded, handleExpand: handleExpand, clientId: clientId, documentGridRefresh: documentGridRefresh, documentsExist: documents.length, showUploadModal: showUploadModal }),
            isLoading ? (React.createElement(DefaultLoadingComponent, { height: 20, width: '100%' })) : (React.createElement(Button, { type: "button", variant: "secondary", onClick: function () { return showModal(clientDetails); } },
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "edit-icon" },
                        React.createElement(Icon, { name: "illustration" })),
                    React.createElement("span", null, "Edit Client")))))));
};
